import { MenuItem, Stack, TextField } from "@mui/material";
import React from "react";
import { banques } from "../asset/variables";

export default function CompteBqForm(props) {

    return(
        <Stack display='flex' flex={1} spacing={1}>
            <Stack direction='row' spacing={2} alignItems='center'>
                <TextField autoFocus={!props.noFocus} fullWidth required sx={{minWidth:'200px'}} label={"N° compte"} value={props.compte.num} onChange={(e)=>props.setNum(e.target.value)}/>
                <TextField select fullWidth required sx={{minWidth:'200px'}} label="Banque" value={props.compte.banque} onChange={(e)=>props.setBanque(e.target.value)}>
                    {banques.map(bq=><MenuItem key={bq} value={bq} sx={{textTransform: 'capitalize'}}>{bq}</MenuItem>)}
                </TextField>
            </Stack>   
            <TextField fullWidth required sx={{minWidth:'200px'}} label={"N° compte bancaire"} value={props.compte.num_banque} onChange={(e)=>props.setNum_banque(e.target.value)}/>         
        </Stack>
    )
}